module.exports = __webpack_public_path__ + "img/donante-dulce-leche.06662083.png";